import {Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ElementRef, HostListener} from '@angular/core';


@Component({
	selector: 'component-header',
	templateUrl: './component.header.html',
	styleUrls: ['./component.header.css']
})

export class ComponentHeader implements OnInit, AfterViewInit {

  @Input() isOpenClass: number; //是否公开课
  @Input() isTencent: boolean; //是否腾讯对接
  @Input() headTitle: string; //标题
  @Input() theme: string;
  @Output() onReturn = new EventEmitter<any>(); //退出事件

  isPC: boolean = false;

  constructor(private el: ElementRef) {}

  ngOnInit() {
    this.isPC = !!localStorage.getItem('isPC');
    this.theme = this.theme ? this.theme: 'sight';
  }

  ngAfterViewInit() {

  }


  // 返回按钮
  return(){
    this.onReturn.emit();
  }



}



// WEBPACK FOOTER //
// ./src/component/header/component.header.ts